import { useEffect, useRef } from "react";
import api from "../api/riderApi";

// Haversine formula (km)
function haversine(lat1, lng1, lat2, lng2) {
  const R = 6371;
  const dLat = ((lat2 - lat1) * Math.PI) / 180;
  const dLng = ((lng2 - lng1) * Math.PI) / 180;
  const a =
    Math.sin(dLat / 2) ** 2 +
    Math.cos((lat1 * Math.PI) / 180) *
      Math.cos((lat2 * Math.PI) / 180) *
      Math.sin(dLng / 2) ** 2;
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  return R * c * 1000; // Return distance in meters
}

export function useRiderLocation({ enabled }) {
  const lastSentRef = useRef({ lat: null, lng: null, at: 0 });

  useEffect(() => {
    if (!enabled || !("geolocation" in navigator)) return;

    const watchId = navigator.geolocation.watchPosition(
      (pos) => {
        const now = Date.now();
        const { latitude: lat, longitude: lng, accuracy } = pos.coords;
        const last = lastSentRef.current;
        const distMoved =
          last.lat != null ? haversine(last.lat, last.lng, lat, lng) : Infinity;
        const ageSec = (now - last.at) / 1000;

        // Skip if moved < 25m and < 60s has passed
        if (distMoved < 25 && ageSec < 60) return;

        api
          .put("/location", {
            lat,
            lng,
            accuracy_m: accuracy,
            captured_at: new Date(now).toISOString(),
          })
          .then(() => {
            lastSentRef.current = { lat, lng, at: now };
          })
          .catch((err) => {
            console.warn("Rider location upload failed", err);
          });
      },
      (err) => {
        console.warn("Geolocation watch position error", err);
      },
      { enableHighAccuracy: true, maximumAge: 20000, timeout: 15000 },
    );

    return () => navigator.geolocation.clearWatch(watchId);
  }, [enabled]);
}
